/**
 * サイト共通の meta keywords。
 *
 * NOTE: unhead v3 で `useSeoMeta` の入力型（`MetaFlat`）から非推奨だった `keywords` が
 * 削除されたため、`useHead` の `meta` 配列で `name: 'keywords'` として指定する。
 */
export const SEO_KEYWORDS =
  'ダイエット,だいえっと,瘦せない,瘦せたい,ダイエット方法,食事,カロリー,レシピ,ダイエットプラス,管理栄養士';
